module.exports = require("core-js/modules/es.object.assign");